function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.2226 69.9993L74.5525 56.2977V46L46.9565 69.1527L47.1331 70.9945L74.5525 94V83.6997L58.2226 69.9993Z",
  fill: "#E25F9E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.3128 93.5479H46.5136L54.8718 62.4944H46.8854L43.4372 75.3574L39.9891 62.4944H32L40.3128 93.5479Z",
  fill: "#ABCD03"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.5617 46.4709H40.3622L32 77.5231H39.9891L43.4372 64.66L46.8854 77.5231H54.8718L46.5617 46.4709Z",
  fill: "#3FB8EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.327 90.0475H181.435V92.8042H156.236V90.0475H167.266V73.6815H156.999V70.8967H180.646V73.6815H170.327V90.0475Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.257 55.2184H102.001H101.807V53.8635H100.658V55.2184H99.9157V53.2549H101.351H101.625H102.549V52.1006H99.9157V50.4795H103.111V49.2971H95.5273V50.4795H98.4458V52.1006H96.0007V53.2549H98.4458V55.2184H95.3521V56.4181H103.257V55.2184Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.2256 46.5579V59.1708H94.7143H103.831V59.1574H105.308V46.5579H93.2256ZM103.832 57.8252H94.7156V47.8446H103.832V57.8252Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.405 55.1058C177.969 54.6738 177.613 54.1655 177.328 53.6212C176.928 52.8561 176.698 52.2101 176.528 51.4249C176.186 49.7798 176.348 48.0811 176.348 46.4146H174.838V49.2769C174.838 49.9978 174.791 50.7174 174.66 51.429C173.889 55.6569 171.502 56.8179 169.778 57.3663V59.1652C170.792 58.6704 174.098 57.4799 175.605 53.7496C176.803 56.7135 180.007 58.4818 181.488 59.1652H181.491V57.2579C181.281 57.1563 179.197 55.8803 178.405 55.1058Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.364 78.173H243.424V75.3402H233.252C233.28 74.6553 233.28 74.4627 233.28 73.6963V68.1309H230.257V73.8608C230.257 74.6299 230.257 74.8225 230.23 75.3415H219.947V78.1744H229.9C228.362 86.6383 223.396 88.9709 219.939 90.0637V93.6724C221.973 92.6813 228.774 90.2951 231.794 82.8223C234.187 88.7569 240.457 92.296 243.421 93.6724V93.671V89.8417C238.74 87.5799 235.318 85.4532 233.364 78.173Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.175 51.4076H136.215V49.9885H131.118C131.134 49.6461 131.134 49.5445 131.134 49.1619V46.3745H129.619V49.2462C129.619 49.6314 129.619 49.7277 129.605 49.9885H124.456V51.4076H129.441C128.67 55.6463 126.185 56.8126 124.452 57.3623V59.168C125.471 58.6718 128.878 57.4774 130.392 53.7349C131.589 56.7083 134.728 58.4805 136.215 59.168H136.218V57.2486C133.867 56.1171 132.153 55.0511 131.175 51.4076Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.764 68.1362V78.8579H140.115V69.966V68.1443L137.278 68.1563V78.8579H132.454C132.451 78.5944 132.467 68.1496 132.467 68.1496H129.576V78.8579H125.328V81.6975H129.515C129.406 82.9026 129.181 84.097 128.742 85.2192C128.032 87.0222 126.728 88.4199 125.341 89.7414V93.651C125.36 93.6697 126.446 92.7187 126.977 92.2292C129.025 90.3326 131.068 88.5349 131.847 85.7515C132.215 84.4367 132.356 83.0711 132.417 81.6975H137.281V82.4558V93.5935H140.118V81.6975H145.732H145.765V81.8794V82.3194V93.5119H148.66V69.0163V68.1362H145.764Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.798 50.6159V49.1847H115.696V46.3826H114.106V49.1847H108.964V50.6159H110.968V57.7275H108.964V59.1573H120.799V57.7275H118.819L118.817 50.6159H120.798ZM117.232 57.7275H116.78H115.231H115.217H112.556L112.553 50.6159H117.232V57.7275Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.458 85.9616V83.5166H264.059L263.986 83.4644C263.986 83.4644 269.758 79.8344 269.684 79.8344V77.4148H255.294V79.8344H264.913L261.201 82.0507V83.5166H250.58V85.9616H261.201V90.2604C261.185 90.441 261.078 90.9747 260.422 91.0282H257.939V93.4973H263.247C264.057 93.4478 264.055 92.6693 264.055 92.6693C264.055 92.6693 264.058 92.6734 264.061 92.6747V85.9603H274.458V85.9616Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.288 75.4111H271.67V79.8931H274.444V73.1038H269.551L271.062 68.3021H268.33L266.69 73.1038H265.791H262.437V68.2927H259.704V73.1038H257.794V68.2927H255.062V73.1038H254.965H250.569V79.8931H253.288V75.4111Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.515 55.4056V54.1804H146.319L146.28 54.1537C146.28 54.1537 149.167 52.3427 149.13 52.3427V51.1335H141.936V52.3427H146.743L144.888 53.4475V54.1804H139.579V55.4043H144.888V57.5537C144.88 57.6446 144.828 57.9108 144.501 57.9376H143.26V59.1708H145.911C146.319 59.148 146.314 58.7575 146.314 58.7575C146.314 58.7575 146.319 58.7575 146.319 58.7588V55.4056H151.515Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.933 50.1317H150.12V52.3707H151.511V48.9787H149.062L149.815 46.5792H148.456L147.634 48.9787H147.184H145.507V46.5725H144.141V48.9787H143.188V46.5725H141.821V48.9787H141.771H139.572V52.3707H140.933V50.1317Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.882 55.7212H164.334L164.881 57.4132L165.03 57.876H161.07L163.583 53.5531H166.283V52.1955H163.583V49.9992H166.283V48.6684H163.583L163.588 46.8199V46.3799H162.023V48.6684H159.312V49.9992H162.023V52.1955H159.312V53.5531H161.884L159.312 57.876V59.2095H165.461H165.521H167.005L165.882 55.7212Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.862 48.6685H154.883V49.9993H157.862V48.6685Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.862 52.2236H154.883V53.5531H157.862V52.2236Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.878 57.7354V59.711L157.887 56.4461V54.425L154.878 57.7354Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.384 86.7277V89.7037C115.366 89.8883 115.248 90.4273 114.582 90.4661H113.072C112.866 90.438 112.384 90.3083 112.338 89.685V75.5607V75.2036C112.285 74.5335 111.732 74.4345 111.564 74.4198L104.686 74.4211H102.778C102.781 71.4598 102.786 68.0879 102.786 68.0879H99.8945V74.4211H93.1079V77.2112H99.8945V79.3927C99.8945 82.1574 99.8665 85.3247 98.442 87.7884C97.8802 88.7554 97.0831 89.6302 96.0545 90.1023C95.1503 90.513 94.079 90.5611 93.1079 90.5611C93.1079 91.4907 93.1079 92.4189 93.1079 93.3472C93.1079 93.4047 95.1276 93.2108 95.2974 93.18C96.0572 93.0449 96.8022 92.8162 97.487 92.4591C98.9449 91.6993 100.129 90.4019 100.967 89.0109C101.477 88.1749 101.902 87.2226 102.166 86.281C102.533 84.9649 102.681 83.6046 102.738 82.231L102.774 79.39C102.774 79.3258 102.774 78.1127 102.774 77.2085H108.662C108.777 77.2152 109.419 77.3075 109.471 78.0338C109.471 78.0338 109.471 92.5219 109.471 92.5206C109.521 93.3338 110.299 93.3298 110.299 93.3311H115.383H117.196C117.196 93.3311 117.209 93.3311 117.206 93.3298C117.206 93.3298 117.987 93.3338 118.037 92.5219V86.7277H115.384Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.081 85.9815H212.786V83.7491H201.592V82.3996H209.367V80.3037H201.592V78.9835H211.062V76.7766H205.795H205.638V74.2674H206.749H212.757V72.035H208.366L209.675 68.1428H207.079L205.76 72.035H204.047V69.253V68.1562H201.429V72.035H199.115V68.1562H196.495V69.253V72.035H194.779L193.463 68.1428H190.867L192.174 72.035H187.785V74.2674H193.793H194.903V76.7766H194.75H189.481V78.9835H198.951V80.3037H191.177V82.3996H198.951V83.7491H187.757V85.9815H197.462C195.766 87.5036 191.498 89.324 187.512 90.7953V93.5372C189.834 92.6678 196.332 90.172 198.952 87.4728V93.5372H201.599V87.4728C204.222 90.172 210.716 92.6678 213.039 93.5372V90.7953C209.048 89.324 204.777 87.5036 203.081 85.9815ZM197.52 76.7753V74.266H203.018V76.7753H197.52Z",
  fill: "black"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 242.458,
  height: 48,
  fill: "white",
  transform: "translate(32 46)"
})));

function SvgLogoKyutech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKyutech);
export default __webpack_public_path__ + "static/media/logo_kyutech.2a9efec0.svg";
export { ForwardRef as ReactComponent };